import { Component, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PermissionService } from '../../../../../core/services/permission';
import { JobItem } from '../../../../../data/models';
import { RepoCommonService } from '../../../../../data/repositories/repo-common.service';

type TranslateMap = {
    PCPS?: string;
    P?: string;
    PC?: string;
    PS?: string;
};

@Component({
    selector: 'app-job-actual-items-detail',
    templateUrl: './job-actual-items-detail.component.html',
    standalone: false,
})
export class JobActualItemsDetailComponent implements OnInit {
    // @ts-ignore TS2564
    item: JobItem & { ItemTypeCode?: keyof TranslateMap };
    // @ts-ignore TS2564
    parent: JobItem;
    translated: TranslateMap = {};
    action = new EventEmitter();
    unitMeasures: string[] = [];

    constructor(
        private bsModalRef: BsModalRef,
        private translateService: TranslateService,
        public permissionService: PermissionService,
        private repoCommon: RepoCommonService
    ) {}

    ngOnInit(): void {
        this.translated.PCPS = this.translateService.instant('general.pc-ps');
        this.translated.P = this.translateService.instant('estimates.costings.btns.p');
        this.translated.PC = this.translateService.instant('estimates.costings.btns.pc');
        this.translated.PS = this.translateService.instant('estimates.costings.btns.ps');
        this.repoCommon.GetUnitMeasures().then((results) => {
            this.unitMeasures = results.map((i) => i.Description).sort();
        });
    }

    getItemCodeLabel(itemCodeKey?: keyof TranslateMap) {
        if (itemCodeKey) return this.translated[itemCodeKey];
    }

    ok() {
        this.bsModalRef.hide();
        this.action.emit({ cancelled: false, item: this.item });
    }

    cancel() {
        this.bsModalRef.hide();
        this.action.emit({ cancelled: true, item: this.item });
    }
}
